import { inventoryStockApi } from '../../api';
import { ProductStockFilter, UpdateStockSettings } from '../../types/inventory/ProductStockTypes';

const InventoryStockService = {
    /**
     * Obtiene una lista paginada de existencias filtradas.
     * POST /api/inventory/stock/filtered?page=X&size=Y
     */
    getFiltered: async (
        filter: ProductStockFilter,
        page = 0,
        size = 10,
        sort = 'product.name,asc' // 🔍 Ejemplo: ordenar alfabéticamente por nombre de producto
    ) => {
        const response = await inventoryStockApi.addCustom(
            `/filtered?page=${page}&size=${size}&sort=${sort}`,
            filter
        );
        return response.data;
    },
    /**
     * Actualiza el stock mínimo y el punto de reorden de un producto en una sucursal.
     * PUT /api/inventory/stock/update-settings
     */
    updateSettings: async (updateData: UpdateStockSettings) => {
        const response = await inventoryStockApi.modifyCustom(
            `/update-settings`,
            updateData
        );
        return response.data;
    }
};

export default InventoryStockService;
